import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
// validation Formik
import * as Yup from "yup";
import { Formik } from "formik";
import yupconfig from "../../../yupconfig";
// import { InputField, SwitchField, InputFieldImage, TextareaField, ReactSelectField } from "../../../component/form/Field";
import customToast from "component/Toastr";
import config from "../../../config";
import { useSelector } from "react-redux";
import { BookingPaymentApi, BookingPaymentFailedApi, BookingStoreApi, NextStep, PreviewStep } from "store/slices/bookingSlice";
import { useDispatch } from "react-redux";
import { ucfirst } from "helpers/Functions";
import moment from "moment";
import { InputField, SelectField, SwitchField, TextareaField } from "component/form/Field";
// import {useCartElementState, CartElement} from '@stripe/react-stripe-js';
import { CardCvcElement, CardExpiryElement, CardNumberElement } from "@stripe/react-stripe-js";
import { useElements, useStripe } from "@stripe/react-stripe-js";
import "assets/css/CardSectionStyles.css";
import { swalErrorHtml } from "component/Sweatalert2";

const BookingStep6 = (props) => {
  console.log('props: ', props);
  const [loading, setLoading] = useState(false);
  const [succeeded, setSucceeded] = useState(false);
  const [error, setError] = useState(null);
  const [disabled, setDisabled] = useState(true);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const stripe = useStripe();
  const elements = useElements();

  const isBookingStep = props.isBookingStep;
  const bookingStepName = props.bookingStepName;
  const isBookingSelectedMembershipData = props.isBookingSelectedMembershipData;
  const isBookingApi = useSelector((state) => state.booking.isBookingApi);
  const price = isBookingSelectedMembershipData && isBookingSelectedMembershipData.cost;
  let cc_code = config.country_codes;
  let countryCodes = [];
  cc_code.map((name) => countryCodes.push({ value: name.code, label: name.flag + " " + name.country_name + " (" + name.code + ")" }));

  const initialValues = {
    bookingStepName: "",
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    description: "",
    number: "",
    exp_month: "",
    exp_year: "",
    cvc: "",
    emailnotification: "",
    country_code: "",
    BookingSelectedMembershipData: [],
  };

  // const digitOnly = (value) => /^\d+$/.test(value);
  // const decimalOnly = (value) => /^\d{1,6}(\.\d{1,2})?$/.test(value);

  const validationSchema = Yup.object().shape({
    bookingStepName: Yup.string().trim().label(t("Booking Step Name")).required(),
    first_name: Yup.string().trim().max(100).label(t("First Name")).required(),
    last_name: Yup.string().trim().max(100).label(t("Last Name")).required(),
    phone_number: Yup.string().trim().matches(config.phone_number_pattern, t(config.phone_number_433_error)).label(t("Mobile")).required(),
    email: Yup.string().trim().max(200).email().label(t("Email Address")).required(),
    description: Yup.string().trim().label(t("Comments")),
    country_code: Yup.string().trim().label(t("Country code")).required(),
    // number: Yup.string().required('Credit card number is required').matches(/^\d{4}(\s\d{4}){3}$/, 'Credit card number must be a valid 16-digit number with a space after every 4 digits'),
    // exp_month: Yup.number().required("Expiration month is required").min(1, 'Expiration month must be between 1 and 12').max(12, 'Expiration month must be between 1 and 12').integer('Expiration month must be a whole number')
    //   .test('expiration', 'Expiration cannot be in the past', function (value) {
    //     const currentDate = new Date();
    //     const currentYear = currentDate.getFullYear();
    //     const currentMonth = currentDate.getMonth() + 1;
    //     if (value < currentMonth && this.parent.exp_year === currentYear) {
    //       return false;
    //     }
    //     return true;
    //   }),
    // exp_year: Yup.number().required("Expiration year is required").min(new Date().getFullYear(), 'Expiration year must be greater than or equal to the current year').integer('Expiration year must be a whole number'),
    // cvc: Yup.string().required("CVV is required").matches(/^\d{3,4}$/, 'CVV must be a 3 or 4-digit number'),
    BookingSelectedMembershipData: Yup.object()
      .shape({
        // service_id: Yup.lazy((val) => (Array.isArray(val) ? Yup.array().of(Yup.string()).nullable().min(1).required() : Yup.string().nullable().label(t("Service")).required())),
        id: Yup.number().positive().label(t("Package")).required(),
      })
      .required(),
  });
  yupconfig();

  const handleBookingSubmit = async (values, { setErrors, setStatus, setSubmitting, resetForm }) => {
    setLoading(true);
    try {
      if (!stripe || !elements) {
        console.log('Stripe or elements not loaded');
        return;
      }
      // let CardElement = elements.getElement(CardElement);
      const { token, error } = await stripe.createToken(elements.getElement(CardNumberElement));
     
      if (error) {
        setError(error.message);
        setLoading(false);
      } else {
        const stripe_token_id = token.id;
        dispatch(BookingStoreApi({ ...values, stripe_token_id })).then((action) => {
          if (action.meta.requestStatus === "fulfilled") {
            const bookingstoredata = action.payload;
            const clientSecret = bookingstoredata.clientSecret;
            const clientname = bookingstoredata.name;
            const clientemail = bookingstoredata.email;
            const clientphone = bookingstoredata.phone;
            const stripe_payment_method_id = bookingstoredata.stripe_payment_method_id;
            const type = action && action.payload && action.payload.type ? action.payload.type : "" ;
            if (clientSecret) {
              stripe
                .confirmCardPayment(
                  clientSecret,
                  {
                    payment_method: stripe_payment_method_id,
                    // return_url: "http://localhost:3000",
                  },
                  // { handleActions: false },
                )
                .then(function (result) {
                  // Handle result.error or result.paymentIntent
                  if (result.error) {
                    setError(`Payment failed ${result.error.message}`);
                    setLoading(false);
                    setStatus({ error: true, message: `Payment failed ${result.error.message}` });
                    const valuespf = { ...bookingstoredata, error: result.error };
                    dispatch(BookingPaymentFailedApi(valuespf));
                  } else {
                    const paymentIntent = result.paymentIntent;
                    if (paymentIntent && paymentIntent.id && paymentIntent.status === "succeeded") {
                      const valuesp = { ...bookingstoredata, paymentIntent: { id: paymentIntent.id, status: paymentIntent.status },type };
                      setError(null);
                      dispatch(BookingPaymentApi(valuesp)).then((actionpayment) => {
                        if (actionpayment.meta.requestStatus === "fulfilled") {
                          setStatus({ success: true });
                          resetForm();
                          setLoading(false);
                          setSucceeded(true);
                          dispatch(NextStep(0));
                          customToast.success(t("Appointment Booking Successfully."));
                        } else if (actionpayment.meta.requestStatus === "rejected") {
                          const status = actionpayment.payload && actionpayment.payload.status;
                          const response = action.payload && action.payload.message && action.payload.message;
                          const errors = actionpayment.payload && actionpayment.payload.message && actionpayment.payload.message.errors;
                          if (status === 422) {
                            const NotifyContent = () => {
                              return (
                                <>
                                  <p className="mb-2 text-danger salert text-justify">{response && response.message}</p>
                                  <ul className="list-unstyled">
                                    {errors &&
                                      Object.keys(errors).map((a, n) => {
                                        if (errors[a].length > 0) {
                                          return (
                                            <>
                                              {errors[a].map((as, ns) => {
                                                return (
                                                  <li key={n + "-" + ns} className="text-danger salert form-text text-start">
                                                    {as}
                                                  </li>
                                                );
                                              })}
                                            </>
                                          );
                                        }
                                      })}
                                  </ul>
                                </>
                              );
                            };
                            swalErrorHtml({ title: "Warning", html: <NotifyContent />, icon: "error" });
                            setErrors(errors);
                          } else if (status === 410) {
                            const NotifyContent = () => {
                              return (
                                <>
                                  <p className="mb-2 text-white text-justify">{response && response.message}</p>
                                </>
                              );
                            };
                            customToast.error(<NotifyContent />);
                            setStatus({ warning: response && response.message, booked: response && response.booked });
                          }
                          setLoading(false);
                          setStatus({ success: false });
                          setSubmitting(false);
                        }
                      });
                    }
                  }
                })
            };
            //customToast.success(t("Created Successfully"));
          } else if (action.meta.requestStatus === "rejected") {
            const status = action.payload && action.payload.status;
            const response = action.payload && action.payload.message && action.payload.message;
            const errors = action.payload && action.payload.message && action.payload.message.errors;
            if (status === 422) {
              const NotifyContent = () => {
                return (
                  <>
                    <p className="mb-2 text-danger salert text-justify">{response && response.message}</p>
                    <ul className="list-unstyled">
                      {errors &&
                        Object.keys(errors).map((a, n) => {
                          if (errors[a].length > 0) {
                            return (
                              <>
                                {errors[a].map((as, ns) => {
                                  return (
                                    <li key={n + "-" + ns} className="text-danger salert form-text text-start">
                                      {as}
                                    </li>
                                  );
                                })}
                              </>
                            );
                          }
                        })}
                    </ul>
                  </>
                );
              };
              swalErrorHtml({ title: "Warning", html: <NotifyContent />, icon: "error" });
              setErrors(errors);
            } else if (status === 410) {
              const NotifyContent = () => {
                return (
                  <>
                    <p className="mb-2 text-white text-justify">{response && response.message}</p>
                  </>
                );
              };
              customToast.error(<NotifyContent />);
              setStatus({ warning: response && response.message, booked: response && response.booked });
            }
            setSubmitting(false);
            setLoading(false);
          }
        });
      }
    } catch (err) {
      setErrors(err.message);
      setStatus({ success: false });
      setLoading(false);
    }
  };
  
  function formatCardNumber(value) {
    const v = value.replace(/\s+/g, "").replace(/[^0-9]/gi, "").substr(0, 16);
    const parts = [];

    for (let i = 0; i < v.length; i += 4) {
      parts.push(v.substr(i, 4));
    }

    return parts.length > 1 ? parts.join(" ") : value;
  }

  const handleCardNumberChange = (e, setFieldValue) => {
    const { value } = e.target;
    const formattedValue = formatCardNumber(value);
    setFieldValue('number', formattedValue);
  };

  const handleChange = async (event) => {
    // Listen for changes in the CardElement
    // and display any errors as the customer types their card details
    setDisabled(event.empty);
    setError(event.error ? event.error.message : "");
  };

  const detail = {
    bookingStepName: bookingStepName,
    uid: isBookingApi.uid,
    salon_id: isBookingApi.salon && isBookingApi.salon.id,
    // first_name: "Test",
    // last_name: "Test",
    // phone_number: "2323-232-332",
    // email: "clientrr11@mailinator.com",
  };

  // Add payment summary from props
  const { paymentSummary } = props;

  return (
    <React.Fragment>
      <Formik 
        enableReinitialize={false} 
        initialValues={initialValues} 
        validationSchema={validationSchema} 
        onSubmit={(values, helpers) => {
          console.log('Form submitted', values);
          handleBookingSubmit(values, helpers);
        }}
      >
        {(formik) => {
          useEffect(() => {
            // if (formik.values.bookingstep !== "") {
            //   dispatch(NextStep(isBookingStep));
            // }
            const fields = ["bookingStepName", "uid", "salon_id"];
            fields.forEach((field) => {
              if (["salon_id"].includes(field)) {
                formik.setFieldValue(field, parseInt(detail[field]), false);
              } else {
                formik.setFieldValue(field, detail[field] ? detail[field] : "", false);
              }
            });
          }, [detail]);

          useEffect(() => {
            formik.setFieldValue(`country_code`, config.default_country_code, true);
          }, []);

          useEffect(() => {
            if (isBookingSelectedMembershipData) {
              formik.setFieldValue("BookingSelectedMembershipData", isBookingSelectedMembershipData, false);
            }
          }, [isBookingSelectedMembershipData]);
          // console.log('formik.errors',formik.errors);
          let totalpayamount = 0;
          return (
            <form id="payment-form" noValidate onSubmit={formik.handleSubmit}>
              <div className="please-sele">
                <a
                  role="button"
                  onClick={() => {
                    //dispatch(BookingSelectedMembershipData({ ...singleSelectedServiceData, datetime: "" }));
                    // dispatch(PreviewStep(isBookingStep));
                    props?.setMakePaymentinfoShow("hide")
                  }}
                >
                  <img src={config.imagepath + "left-arrow.svg"} alt="" className="me-3" width="21" />
                  {t("Please make payment")}
                </a>
              </div>
            
              <div className="items-list">
                <div className="confirm-from-cover">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <InputField type="text" name="first_name" value={formik.values.first_name} label={t("First Name") + "*"} controlId="bookingForm-first_name" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <InputField type="text" name="last_name" value={formik.values.last_name} label={t("Last Name") + "*"} controlId="bookingForm-last_name" />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <SelectField name="country_code" placeholder={t("-Select-")} value={formik.values.country_code} options={countryCodes} label={t("Country code")} controlId="clientForm-salon_type" />
                    </div>
                    <div className="col-md-6 mb-3">
                      <InputField type="text" name="phone_number" value={formik.values.phone_number} mask={config.phone_number_mask} label={t("Mobile") + "*"} controlId="bookingForm-phone_number" />
                    </div>
                  </div>
                  <div className="col-md-12 mb-3">
                    <InputField type="text" name="email" value={formik.values.email} label={t("Email Address") + "*"} controlId="bookingForm-email" />
                  </div>
                  <div className="col-md-12 mb-4">
                    <TextareaField type="text" name="description" placeholder={t("For example, allergic to latex")} value={formik.values.description} label={t("Comments")} controlId="bookingForm-description" />
                  </div>
                  <div className="bookin-mess col-12">
                    <h3>{t("A payment of AUD ${{ price }} is required to  complete your purchase.", { price: price })}</h3>
                  </div>
                  <div className="col-md-12 mb-3">
                    <div className="pay-card-details-wr">
                      <h4 htmlFor="" className="fw-600">Card Details</h4>
                      {/* <div className="pay-card-no">
                        <InputField name="number" value={formik.values.number} controlId="number" placeholder="1234 1234 1234 1234" onChange={(e) => handleCardNumberChange(e, formik.setFieldValue)} />
                      </div>
                      <div className="month-cvc-wr">
                        <div className="row gx-2">
                          <div className="col-sm-4 mb-3">
                            <InputField name="exp_month" value={formik.values.exp_month} controlId="exp_month" placeholder="MM" />
                          </div>
                          <div className="col-sm-4 col-6 mb-3">
                            <InputField name="exp_year" value={formik.values.exp_year} controlId="exp_year" placeholder="YYYY" />
                          </div>
                          <div className="col-sm-4 col-6 mb-3">
                            <InputField name="cvc" value={formik.values.cvc} controlId="cvc" placeholder="cvv" />
                          </div>
                        </div>
                      </div> */}
                      <div className="row">
                        <div className="col-12 mb-3">
                          <label htmlFor="card-number">Card Number</label>
                          <CardNumberElement
                            id="card-number"
                            options={{
                              style: {
                                base: {
                                  fontSize: '16px',
                                  color: '#32325d',
                                  fontFamily: 'Arial, sans-serif',
                                  '::placeholder': {
                                    color: '#aab7c4',
                                  },
                                },
                                invalid: {
                                  color: '#fa755a',
                                },
                              },
                            }}
                          />
                        </div>
                        <div className="col-6 mb-3">
                          <label htmlFor="card-expiry">Expiration Date</label>
                          <CardExpiryElement
                            id="card-expiry"
                            options={{
                              style: {
                                base: {
                                  fontSize: '16px',
                                  color: '#32325d',
                                  fontFamily: 'Arial, sans-serif',
                                  '::placeholder': {
                                    color: '#aab7c4',
                                  },
                                },
                                invalid: {
                                  color: '#fa755a',
                                },
                              },
                            }}
                          />
                        </div>
                        <div className="col-6 mb-3">
                          <label htmlFor="card-cvc">CVC</label>
                          <CardCvcElement
                            id="card-cvc"
                            options={{
                              style: {
                                base: {
                                  fontSize: '16px',
                                  color: '#32325d',
                                  fontFamily: 'Arial, sans-serif',
                                  '::placeholder': {
                                    color: '#aab7c4',
                                  },
                                },
                                invalid: {
                                  color: '#fa755a',
                                },
                              },
                            }}
                          />
                        </div>
                      </div>
                      {error && (
                        <div id="card-errors" className="card-error invalid-feedback d-block mb-4" role="alert">
                          {error}
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="ps-3">
                    <SwitchField
                      name="emailnotification"
                      label={t("I want to receive emails with latest news, offers and updates.")}
                      controlId="bookingForm-emailnotification"
                      value="1"
                      onChange={(e) => {
                        if (e.currentTarget.checked) {
                          // setTimeout(() => {
                          formik.setFieldValue("emailnotification", 1, false);
                          // }, 100);
                        } else {
                          // setTimeout(() => {
                          formik.setFieldValue("emailnotification", "", false);
                          // }, 100);
                        }
                        //formik.handleChange(e);
                      }}
                    />
                  </div>
                  {/* <div className="col-md-12 mb-3"> */}
                  {/* <CardElement className="card" /> */}
                  {/* <CardNumberElement />
                        <CardExpiryElement />
                        <CardCvcElement /> */}
                  {/* <CardElement id="card-element" options={cardStyle} onChange={handleChange} /> */}
                  {/* <CardCvcElement /> */}
                  {/* <PaymentElement /> */}
                  {/* </div> */}
                  {/* <button type="submit" className="btn btn-primary w-100 btn-lg" disabled={loading}>
                        {loading && <span className="spinner-border spinner-border-sm"></span>}
                        {t("Pay") + totalpayamount}
                      </button> */}
                  <button type="submit" className="btn btn-primary w-100 btn-lg" disabled={loading}>
                    {loading && <span className="spinner-border spinner-border-sm"></span>}
                    {t("Pay now")}
                  </button>
                </div>
              </div>
            </form>
          );
        }}
      </Formik>
    </React.Fragment>
  );
};

BookingStep6.propTypes = {
  isBookingStep: PropTypes.number,
  bookingStepName: PropTypes.string,
  isBookingSelectedMembershipData: PropTypes.oneOfType([PropTypes.node, PropTypes.array, PropTypes.object]),
  paymentSummary: PropTypes.shape({
    selectedItems: PropTypes.arrayOf(
      PropTypes.shape({
        treatmentId: PropTypes.number,
        treatmentName: PropTypes.string,
        staffId: PropTypes.number,
        staffName: PropTypes.string,
        price: PropTypes.number
      })
    ),
    totals: PropTypes.shape({
      subtotal: PropTypes.number,
      discount: PropTypes.number,
      taxes: PropTypes.number,
      total: PropTypes.number
    })
  })
};
export default BookingStep6;
